import React from 'react';
// import PropTypes from 'prop-types';
const ReactMarkdown = require("react-markdown");


const ArticleMarkdown = ({content}) => {
  return (
    <>
      <div className="article__markdown">
        <ReactMarkdown source={content} />  
      </div>
    </>
  );
};

// ArticleMarkdown.propTypes = {};

export default ArticleMarkdown;
